import { Input } from "@headlessui/react";
import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { asArray, rawValue } from "../../lib/node";
import { useSetter } from "../../lib/useSetter";

/**
 * Rendered under any widget body. This is what lets a pump be BUTTONS plus
 * inputs and the settings card be NONE plus inputs, with no special casing.
 */
export default function ParamInputs({
  node,
  ctx,
}: {
  node: INode;
  ctx: ServiceContextType;
}) {
  const { onRangeChange } = useSetter();
  const inputs = asArray(node.inputs);
  if (!inputs.length) return null;

  return (
    <div className="flex flex-wrap gap-4 mt-4">
      {inputs.map((inp, i) => (
        <div key={i} className="mb-2">
          <div className="text-sm opacity-60">{inp.label}</div>
          <Input
            type="number"
            className="rounded-md border border-gray-400 bg-white/5 p-2 w-32"
            value={rawValue(ctx, inp.addr ?? node.addr, inp.key) ?? ""}
            onChange={onRangeChange(inp.addr ?? node.addr, inp.key, 500)}
          />
        </div>
      ))}
    </div>
  );
}
